// extracted by mini-css-extract-plugin
export default {"langFlag":"SwitchButton_langFlag__A5A-H","langSwitch":"SwitchButton_langSwitch__H+MNQ"};